import React, { useRef, useEffect, useState, useContext } from 'react';
import { useCountUp } from 'react-countup';
import { gsap } from 'gsap';
import truck from '../../assets/truck.svg';
import './Statistics.scss';
import { WidthContext } from '../../WidthContext';

function Statistics2() {
  const barsRef = useRef();
  const bar1Ref = useRef();
  const bar2Ref = useRef();
  const [showCounter, setShowCounter] = useState(false);
  const width = useContext(WidthContext);
  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: barsRef.current,
        start: 'top 75%',
        end: 'top 75%',
        once: true,
        onEnter: () => {
          setShowCounter(true);
        }
      }
    });

    tl.to(bar1Ref.current, { width: width > 767 ? '25.80%' : '40%', duration: 1.2 }).to(
      bar2Ref.current,
      { width: width > 767 ? '86%' : '100%', duration: 1.2 },
      '-=1.2'
    );
  }, [width]);

  const SimpleHookMiles = () => {
    useCountUp({
      ref: 'counterMiles',
      end: 15,
      start: 0,
      duration: 1.2
    });
    return <span id="counterMiles" />;
  };
  const SimpleHookMiles2 = () => {
    useCountUp({
      ref: 'counterMiles2',
      end: 50,
      start: 0,
      duration: 1.2
    });
    return <span id="counterMiles2" />;
  };

  return (
    <figure className="statistics">
      <div className="statistics__graphic">
        <h3 className="statistics__graphic__title statistics__graphic__title-2">
          distance between home purchased and previous residence
        </h3>
        <div className="statistics__graphic__graph" ref={barsRef}>
          <p className="statistics__graphic__graph__copy year">2021</p>
          <div className="bar bar-2">
            <div className="bar-container">
              <div className="bar-left-2" ref={bar1Ref} />
              <img className="bar-icon" src={truck} alt="" />
            </div>
            <p className="bar-number" id="num15">
              {showCounter ? <SimpleHookMiles /> : `0`} miles
            </p>
          </div>
        </div>

        <div className="statistics__graphic__graph">
          <p className="statistics__graphic__graph__copy year">2022</p>
          <div className="bar bar-2">
            <div className="bar-container">
              <div className="bar-left-2" ref={bar2Ref} />
              <img className="bar-icon bar-icon--bottom" src={truck} alt="" />
            </div>
            <p className="bar-number " id="num50">
              {showCounter ? <SimpleHookMiles2 /> : `0`} miles{' '}
              <span className="bar-number--small">(all-time high)</span>
            </p>
          </div>
        </div>
      </div>
      <figcaption className="captions">Source: NAR, 2022</figcaption>
    </figure>
  );
}

export default Statistics2;
